<template>
  <SideBar
    data-tourid="rev-view-sidebar"
    tourIdPrefix="rev-view"
    :modelType="modelType"
    :modelName="modelName"
    :modelId="modelId"
    :submitText="submitText"
    :submitCommentTestId="submitCommentTestId"
    :canEdit="canEdit"
    :isEditMode="isEditMode"
    :rev="rev"
    :errors="errors"
    :tags="tags"
    :organizationId="organizationId"
    :hasChallengeActive="hasChallengeActive"
    :hasCommentsActive="hasCommentsActive"
    :hasAttachmentsActive="hasAttachmentsActive"
    @onChallengeChange="onChallengeChange"
    @onLocationChange="onLocationChange"
    @notesChanged="notesChanged"
    @priorityChanged="priorityChanged"
    @onDueDateChange="onDueDateChange"
  />
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import SideBar from '@/containers/SideBar.vue'

export default {
  name: 'RevSidebar',

  components: {
    SideBar,
  },

  mixins: [mixin, trackerMixin],

  props: {
    modelType: {
      type: String,
      required: false,
    },
    modelName: {
      type: String,
      required: true,
    },
    modelId: {
      type: String,
      required: true,
    },
    submitText: {
      type: String,
      required: false,
    },
    submitCommentTestId: {
      type: String,
      required: false,
      default: 'comment_submit_btn',
    },
    canEdit: {
      type: Boolean,
      required: false,
    },
    isEditMode: {
      type: Boolean,
      required: false,
    },
    hasChallengeActive: {
      type: Boolean,
      required: false,
    },
    hasCommentsActive: {
      type: Boolean,
      required: false,
    },
    hasAttachmentsActive: {
      type: Boolean,
      required: false,
    },
    rev: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    errors: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    tags: {
      type: Array,
      required: false,
      default: function () {
        return []
      },
    },
  },

  data() {
    return {
      organizationId: this.getOrganizationId(),
    }
  },

  methods: {
    onLocationChange(attrs) {
      this.$emit('locationChange', attrs)
    },

    onChallengeChange() {
      this.$emit('revChanged')
      this.trackUpdate(this.rev, 'challenge')
    },

    notesChanged(notes) {
      this.$emit('revChanged')
      this.$emit('onNotesChange', notes)
    },
    priorityChanged(priority) {
      this.$emit('priorityChanged', priority)
    },
    onDueDateChange(date) {
      this.$emit('onDueDateChange', date)
    },
  },
}
</script>
